import { useBreakpointValue } from '@genial/utils';
import { ScrollView, View } from 'native-base';
import React from 'react';

import { MainContainer } from './components/MainContainer';

interface BatchTicketResumeProps {}

export const BatchTicketResume: React.FC<BatchTicketResumeProps> = () => {
  const Wrapper = useBreakpointValue({
    base: ({ children }) => <View minW="container">{children}</View>,
    lg: ({ children }) => (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View minW="container">{children}</View>
      </ScrollView>
    ),
  });

  return (
    <Wrapper>
      <MainContainer />
    </Wrapper>
  );
};
